import React, { useContext } from "react";
import { LoginContext } from "../../services/api/authentication-api";
import "./user-detail-label.scss";

const UserDetailLabel = () => {
    const { currentUser, userID } = useContext(LoginContext);
    let user;
    let strLabel;

    try
    {
        if (!currentUser) {
            let persistRoot = JSON.parse(window.localStorage.getItem('persist:root'));
            user = JSON.parse(persistRoot.currentUser).user;
        } else {
            user = currentUser;
        }

        if (!user) {
            strLabel = ""
        } else {
            strLabel = user.profile.userName + "-" + user.profile.strRole + "-" + user.department.Name;
        }
    } catch (error) {
        console.log("UserDetailLabel => Error parsing user data:", error);
        strLabel = "";
    }

    return (
        <span className="profile-label-container">
            <div className="profile-label-area">
                {strLabel}
            </div>
        </span>
    );
}

export default UserDetailLabel;
